export default __webpack_public_path__ + "static/media/class_xi_xii_medical_m.fe6ce6e4.png";